var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_c('a',{attrs:{"href":"javascript:;"},on:{"click":_vm.onOpenPlayerDetailRequested}},[_vm._v(_vm._s(_vm.event.data.alias))]),_vm._v(" has joined the game.\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }